import { styled } from "@mui/material/styles";

export const Container = styled("div", {
  label: "payment-form",
})`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2.25)};

  &.disabled {
    pointer-events: none;
  }
`;

export const ButtonsRow = styled("div", {
  label: "buttons-row",
})`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(1.25, 1.75)};
  justify-content: center;

  & > * {
    flex: 0 1 ${({ theme }) => theme.spacing(30)};
  }
`;
